import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/data.service";
import { EnvironmentService } from "../models/environment-service";
import { ODataResponse } from '../models/odata-response';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config.service';

@Injectable({
  providedIn: "root",
})
export class EnvironmentServiceDataService extends DataService<
  EnvironmentService
> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "EnvironmentServices", acs);
  }

  linkCount(
    serviceId: number,
  ) {
    let url = `${this.acs.current.configApiUrl}odata/EnvironmentServices?$filter=ServiceId eq ${serviceId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<EnvironmentService>>(url);
  }  

  linkCountByEnvironment(
    environmentId: number,
  ) {
    let url = `${this.acs.current.configApiUrl}odata/EnvironmentServices?$filter=EnvironmentId eq ${environmentId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<EnvironmentService>>(url);
  }
  
  linkExists(
    environmentId: number,
    serviceId: number
  ) {
    let url = `${this.acs.current.configApiUrl}odata/EnvironmentServices?$filter=EnvironmentId eq ${environmentId} and ServiceId eq ${serviceId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<EnvironmentService>>(url).pipe(
      switchMap((r) => {
        let exists = +r['@odata.count'] > 0;
        return of(exists);
      })
    );
  } 
}
